export default class RestingRater {
  constructor() {
    this.sex = 'm'
    this.age = 30
    this.age_range = this.age_ranges[1]
    this.bpm = 77
    this.sex_age_ranges = [] // holds range info for specific sex and age

    this.update()
  }

  emoji = [
    '😰',
    '🫤',
    '🙂',
    '😊',
    '😁',
    '😇',
    '🤩',
  ]

  colors = [
    '#ff0000',
    '#ff8a8a',
    '#ff8300',
    '#ffba00',
    '#00a400',
    '#00a2ff',
    '#bd90a4',
  ]

  color = (cat_num=this.catNum()) => this.colors[cat_num]

  catNum = () => this.categories.length - 1 - this.sexRangeI() // because range order is reverse of cat order 

  sexRangeI = () => this.sex_age_ranges.findIndex( (range) => this.bpm >= range[0] && this.bpm < range[1] + 1  )
    

  categories = [
    'not_good',
    'below_average',
    'average',
    'above_average',
    'good',
    'excellent',
    'exceptional',
  ]

  age_ranges = [
    '18-25',
    '26-35',
    '36-45',
    '46-55',
    '56-65',
    '65-100',
  ]

  update = () => {
    this.sex_age_ranges = this.rates[this.sex_key][this.age_key] || []
  }

  get age_key() {
    return this.age_ranges.findIndex( 
      range => this.age_range === range
    )
  }

  sexes = {
    m: 0,
    f: 1
  }

  get sex_key() {
    return this.sexes[this.sex]
  }

  rates = [
    [
      [ [49,55], [56,61], [62,65], [66,69], [70,73], [74,81], [82,100] ],
      [ [49,54], [55,61], [62,65], [66,70], [71,74], [75,81], [82,100] ],
      [ [50,56], [57,62], [63,66], [67,70], [71,75], [76,82], [83,100] ],
      [ [50,57], [58,63], [64,67], [68,71], [72,76], [77,83], [84,100] ],
      [ [51,56], [57,61], [62,67], [68,71], [72,75], [76,81], [82,100] ],
      [ [50,55], [56,61], [62,65], [66,69], [70,73], [74,79], [80,100] ],
    ],
    [
      [ [54,60], [61,65], [66,69], [70,73], [74,78], [79,84], [85,100] ],
      [ [54,59], [60,64], [65,68], [69,72], [73,76], [77,82], [83,100] ],
      [ [54,59], [60,64], [65,69], [70,73], [74,78], [79,84], [85,100] ],
      [ [54,60], [61,65], [66,69], [70,73], [74,77], [78,83], [84,100] ],
      [ [54,59], [60,64], [65,68], [69,73], [74,77], [78,83], [84,100] ],
      [ [54,59], [60,64], [65,68], [69,72], [73,76], [77,84], [85,100] ],
    ],
  ]
}
